import { SwitchRow } from '@/components/SwitchRow'

const SHARE_SWITCH_ID = 'snippet-share-switch'
const HIDE_SWITCH_ID = 'snippet-hide-switch'

interface SnippetShareSwitchesProps {
  isShared: boolean
  isHidden: boolean
  disabled: boolean
  onSharedChange: (isShared: boolean) => void
  onHiddenChange: (isHidden: boolean) => void
}

export function SnippetShareSwitches({
  isShared,
  isHidden,
  disabled,
  onSharedChange,
  onHiddenChange,
}: SnippetShareSwitchesProps) {
  return (
    <div className="flex flex-col divide-y divide-neutral-subtle-border">
      <SwitchRow
        id={SHARE_SWITCH_ID}
        label="Share with all orgs"
        description={
          isShared
            ? 'Every organization can use it.'
            : 'Only your organization can use it.'
        }
        checked={isShared}
        disabled={disabled}
        onCheckedChange={onSharedChange}
      />
      {isShared && (
        <SwitchRow
          id={HIDE_SWITCH_ID}
          label="Hide from other orgs"
          description="Hidden from other organizations' snippets and scripts. Calls still use it."
          checked={isHidden}
          disabled={disabled}
          onCheckedChange={onHiddenChange}
        />
      )}
    </div>
  )
}
